import { useEffect, useState } from 'react';
import { useDebouncedInput } from '@/hooks/useDebouncedInput';
import SearchIcon from '@/assets/icons/search.svg?react';
import styles from './SearchBar.module.scss';

interface ISearchBarProps {
  placeholder: string;
  // eslint-disable-next-line no-unused-vars
  onSearch: (query: string) => void;
  classNames?: string;
}

function SearchBar({ placeholder, onSearch, classNames }: ISearchBarProps) {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebouncedInput(query, 300);

  useEffect(() => {
    onSearch(debouncedQuery);
  }, [debouncedQuery, onSearch]);

  return (
    <div className={`${styles.searchContainer} ${classNames}`}>
      <SearchIcon className={styles.icon} />
      <input type="text" placeholder={placeholder || 'Search'} value={query} onChange={(e) => setQuery(e.target.value)} className={styles.input} />
      {query && (
        <button type="button" className={styles.clearButton} onClick={() => setQuery('')}>
          ×
        </button>
      )}
    </div>
  );
}

export default SearchBar;
